/**
 * 云朵长连接适配器 - 兼容网易NIM SDK接口
 * 实现NIM.getInstance方法的所有回调方法设置
 */
import config from "@/fetch/config/index.js";
import { getCookie, setCookie } from "@/utils/md5.js";
import { DELOP_getOsInfoFn, DELOP_getExploreName, DELOP_getSourse, DELOP_SEVISE, getRsaKey} from "@/utils/common_front.js";
import { EncryptRSA, encryptAES } from "@/utils/encrypt.js";
import {hex_md5} from "../../static/channelAccessDelop/1.0/common";
import {getUsersBatchInfo, getChatMessages} from "../services/chat";

class YunduoAdapter {
  constructor(options) {
    this.options = options;
    this.eventListeners = {};
    this.isConnected = false;
    this.lastSendTime = Date.now();
    this.isConnecting = false;
    this.reconnectAttempts = 0;
    this.maxReconnectAttempts = 5;
    this.reconnectInterval = 3000;
    this.heartbeatInterval = null;
    this.heartbeatreqCount = 0;
    this.heartbeatresCount = 0;
    //当前滚动的会话
    this.scrollconversationId = "";
    //当前滚动加载更多
    this.scollmore = false;
    this.scrollStop = false;
    // 存储传入的初始化参数
    this.initParams = {
      companyId: options.companyId || "",
      childChannelId: options.childChannelId || "",
      groupConversationId: options.groupConversationId || "",
      visitSign: options.visitSign || "",
      visitName: options.visitName || "访客用户"
    };
    // 新增：消息确认相关属性
    this.pendingMessages = new Map(); // 存储等待确认的消息
    this.ackTimeout = 30000; // 确认超时时间（10秒）
    this.messageCounter = 0; // 消息计数器

    // 存储所有回调方法
    this.callbacks = {
      onconnect: options.onconnect,
      onwillreconnect: options.onwillreconnect,
      ondisconnect: options.ondisconnect,
      onerror: options.onerror,
      onmyinfo: options.onmyinfo,
      onupdatemyinfo: options.onupdatemyinfo,
      onsessions: options.onsessions,
      onupdatesession: options.onupdatesession,
      onmsg: options.onmsg,
      onsysmsg: options.onsysmsg,
      onsyncdone: options.onsyncdone
    };

    // 初始化WebSocket连接
    this.initWebSocket();
  }

  /**
   * 初始化WebSocket连接
   */
  initWebSocket() {
    if (this.isConnecting || this.isConnected) {
      return;
    }

    this.isConnecting = true;

    try {
      this.websocket = new WebSocket(config.socketUrl);

      // 连接成功回调
      this.websocket.onopen = (event) => {
        console.log("云朵WebSocket连接成功", event);
        this.isConnected = true;
        this.isConnecting = false;
        this.reconnectAttempts = 0;

        // 发送认证消息
        this.sendAuthMessage();

        // 触发onconnect回调
        if (this.callbacks.onconnect) {
          this.callbacks.onconnect({});
        }

        // 启动心跳检测
        this.startHeartbeat();
      };

      // 接收消息回调
      this.websocket.onmessage = (event) => {
        try {
          const message = JSON.parse(event.data);
          // console.log('收到云朵消息', message);
          this.handleMessage(message);
        } catch (error) {
          console.error("解析消息失败", error);
        }
      };

      // 连接错误回调
      this.websocket.onerror = (error) => {
        console.error("云朵WebSocket连接错误", error);
        this.isConnecting = false;

        // 触发onerror回调
        if (this.callbacks.onerror) {
          this.callbacks.onerror(error, {});
        }

        // 尝试重连
        this.handleReconnect();
      };

      // 连接关闭回调
      this.websocket.onclose = (event) => {
        console.log("云朵WebSocket连接关闭", event);
        this.isConnected = false;
        this.isConnecting = false;

        // 清理所有等待确认的消息
        this.clearPendingMessages();

        // 触发ondisconnect回调
        if (this.callbacks.ondisconnect) {
          this.callbacks.ondisconnect(event);
        }

        // 停止心跳检测
        this.stopHeartbeat();

        // 尝试重连
        this.handleReconnect();
      };
    } catch (error) {
      console.error("初始化WebSocket失败", error);
      this.isConnecting = false;

      if (this.callbacks.onerror) {
        this.callbacks.onerror(error, {});
      }
    }
  }

  /**
   * 发送认证消息
   */
  sendAuthMessage() {
    const authParams = this.getInitParams();
    if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
      this.websocket.send(JSON.stringify(authParams));
    }
  }

  // 根据companyId, timestamp, salt 生成token
  generateToken(companyId, timestamp) {
    var salt = "Yuuxin";
    console.log("@@@@@@@@@@@@@@token", hex_md5(encodeURIComponent(String(3169) + String(1631535803564) + salt)).toUpperCase())
    return hex_md5(encodeURIComponent(String(companyId) + String(timestamp) + salt)).toUpperCase();
  }
  /**
   * 获取初始化参数
   */
  getInitParams() {
    const { account, token } = this.options;
    // 直接使用传入的参数，不再调用内部方法
    const companyId = this.initParams.companyId;
    const childChannelId = this.initParams.childChannelId;
    const groupConversationId = this.initParams.groupConversationId || this.generateUUID();
    const visitSign = this.initParams.visitSign;
    const visitName = this.initParams.visitName;

    const getOsInfo = DELOP_getOsInfoFn();
    const browerNameInfo = DELOP_getExploreName();
    const sourceInfo = DELOP_getSourse();
    const timestamp = new Date().getTime();
    const ydtoken = this.generateToken(companyId, timestamp);
    return {
      yunduoId: account,
      type: "NETTY_AUTH_REQ",
      date: timestamp,
      token: ydtoken,
      module: "im",
      chat: "1",
      platform: 2, // web平台
      deviceId: groupConversationId,
      companyId: companyId,
      visitSign: visitSign,
      visitorName: visitName,
      channelId: 1, // web渠道
      childChannelId: childChannelId,
      conversationId: "",
      systemOS: getOsInfo.name,
      browser: browerNameInfo,
      groupConversationId: groupConversationId,
      title: document.title,
      currentURL: window.location.href,
      device: DELOP_SEVISE(),
      source: sourceInfo.source,
      sourceKeyword: sourceInfo.keyword,
      fromPageTitle: "",
      fromPageURL: sourceInfo.url
    };
  }

  /**
   * 处理收到的消息
   */
  handleMessage(message) {
    if (message.type === "NETTY_AUTH_RES") {
      // 认证响应
      this.handleAuthResponse(message);
    } else if (message.type === "IM_SYS_MSG_RSP") {
      // 会话消息
      this.handleConversationMessage(message.msg.msg);
    } else if (message.type === "SYSTEM_MSG") {
      // 系统消息
      this.handleSystemMessage(message);
    } else if (message.type === "SM_RSP") {
      // 新增：处理消息确认
      this.handleMessageAck(message);
    } else if (message.type === "HB_RSP") {
      this.heartbeatresCount = message.msg;
      if (this.heartbeatreqCount === this.heartbeatresCount) {
        this.heartbeatresCount = 0;
        this.heartbeatreqCount = 0;
      }
    }
  }

  /**
   * 处理消息确认
   */
  handleMessageAck(ackMessage) {
    const { msg, status, message } = ackMessage;
    const msgId = msg.tempMsgId || msg;
    console.log("收到确认消息", ackMessage)
    if (this.pendingMessages.has(msgId)) {
      const pendingMessage = this.pendingMessages.get(msgId);
      console.log("pendingMessage", pendingMessage)
      // 清除超时定时器
      clearTimeout(pendingMessage.timeoutId);
      ackMessage.tips = "会话已关闭";
      if (status === 1) {
        // 发送成功
        console.log(`消息 ${msgId} 发送成功`);
        if (pendingMessage.done) {
          pendingMessage.done(null, {
            idClient: msgId,
            idServer: msg.msgId || msgId,
            type: "text",
            scene: "p2p",
            from: this.options.account,
            to: pendingMessage.to,
            time: pendingMessage.createTime,
            status: "success",
            content: pendingMessage.content,
            text: pendingMessage.content,
            flow: "out"
          });
        }
      } else {
        // 发送失败
        if (pendingMessage.done) {
          //{"date":1767602691429,"msg":"1767602690888_2","status":0,"tips":"会话已关闭","type":"SM_RSP"}
          if (ackMessage.tips === "会话已关闭") {
            this.lastSendTime = this.lastSendTime - 1000;
            pendingMessage.done({error: `消息发送失败: ${pendingMessage.content}`, "code": 20006}, {"type": "text", "text": pendingMessage.content});
            return;
          }
          pendingMessage.done(new Error(`消息发送失败: ${pendingMessage.content}`), null);
        }
      }

      // 从等待列表中移除
      this.pendingMessages.delete(msgId);
    }
  }

  /**
   * 等待消息确认
   */
  waitForAck(msgId, doneCallback) {
    if (!this.pendingMessages.has(msgId)) {
      console.warn(`消息 ${msgId} 不在等待确认列表中`);
      if (doneCallback) {
        doneCallback(new Error("消息ID无效"), null);
      }
      return;
    }

    const pendingMessage = this.pendingMessages.get(msgId);

    const that = this;
    // 设置超时处理
    const timeoutId = setTimeout(() => {
      if (that.pendingMessages.has(msgId)) {
        console.error(`消息 ${msgId} 确认超时`);
        that.pendingMessages.delete(msgId);

        if (doneCallback) {
          doneCallback(new Error("消息确认超时"), null);
        }
      }
    }, this.ackTimeout);

    // 更新等待消息信息
    this.pendingMessages.set(msgId, {
      ...pendingMessage,
      timeoutId: timeoutId,
      done: doneCallback
    });
  }

  /**
   * 发送文本消息（改进版）
   */
  sendText(options) {
    console.log("访客要发送的消息参数", options)
    if (!this.isConnected) {
      console.error("未连接，无法发送消息");
      if (options.done) {
        options.done(new Error("未连接"), null);
      }
      return;
    }
    if (Date.now() - this.lastSendTime < 1000) {
      console.error("发送频率过快");
      if (options.done) {
        options.done(new Error("发送频率过快"), null);
      }
      return;
    }
    this.lastSendTime = Date.now();
    const msgId = this.lastSendTime.toString() + "_" + (this.messageCounter++);
    const textMsg = {
      type: "SM_REQ",
      content: options.text,
      toUserId: options.to,
      custom: options.custom,
      fromUserId: this.options.account,
      msgId: msgId,
      createTime: this.lastSendTime
    };

    try {
      // 发送消息前先添加到等待列表
      this.pendingMessages.set(msgId, {
        msgId: msgId,
        to: options.to,
        content: options.text,
        createTime: textMsg.createTime,
        done: null,
        timeoutId: null
      });

      // 发送消息
      this.websocket.send(JSON.stringify(textMsg));
      console.log(`发送消息 ${msgId} 到服务器`);

      // 等待确认
      this.waitForAck(msgId, options.done);
    } catch (error) {
      console.error("发送消息失败", error);

      // 清理等待列表
      this.pendingMessages.delete(msgId);

      if (options.done) {
        options.done(error, null);
      }
    }
  }

  /**
   * 模拟服务器消息确认（用于测试）
   */
  simulateServerAck(msgId, success = true) {
    const ackMessage = {
      type: "MSG_ACK",
      msgId: msgId,
      code: success ? "1" : "0",
      message: success ? "发送成功" : "发送失败",
      serverMsgId: msgId + "_server"
    };

    // 模拟服务器响应
    setTimeout(() => {
      this.handleMessageAck(ackMessage);
    }, 500);
  }

  /**
   * 获取等待确认的消息数量（用于调试）
   */
  getPendingMessageCount() {
    return this.pendingMessages.size;
  }

  /**
   * 清理所有等待确认的消息（连接断开时调用）
   */
  clearPendingMessages() {
    for (const [msgId, pendingMessage] of this.pendingMessages) {
      clearTimeout(pendingMessage.timeoutId);
      if (pendingMessage.done) {
        pendingMessage.done(new Error("连接断开，消息发送失败"), null);
      }
    }
    this.pendingMessages.clear();
  }

  /**
   * 处理认证响应
   */
  handleAuthResponse(message) {
    if (message.code === "1") {
      console.log("云朵认证成功");
      // 模拟NIM的同步过程
      this.simulateNimSync();
    } else {
      console.error("云朵认证失败", message);
      if (this.callbacks.onerror) {
        this.callbacks.onerror(new Error(message.message || "认证失败"), {});
      }
    }
  }

  /**
   * 处理会话消息
   */
  handleConversationMessage(message) {
    try {
      console.log("处理会话消息:", message);

      // 解析消息内容
      let msgContent;
      if (typeof message === "string") {
        msgContent = JSON.parse(message);
      } else {
        msgContent = message;
      }

      console.log("解析后的消息内容:", msgContent);

      // 处理嵌套的msg字段（IM_SYS_MSG_RSP类型消息）
      if (msgContent.msg && typeof msgContent.msg === "string") {
        try {
          const nestedMsg = JSON.parse(msgContent.msg);
          console.log("解析嵌套的msg字段:", nestedMsg);
          msgContent = nestedMsg;
        } catch (e) {
          console.warn("解析嵌套的msg字段失败:", e);
        }
      }

      // 将云朵消息转换为NIM格式
      const nimMsg = this.convertToNimMessage(msgContent);
      console.log("转换后的NIM消息:", nimMsg);

      const custom = nimMsg.custom ? JSON.parse(nimMsg.custom) : {};
      if (typeof custom.type !== "undefined" && (custom.type === 0 || custom.type === 12)) {
        // 会话激活
        if (this.callbacks.onsessions) {
          const sessions = [
            {
              id: "p2p-" + nimMsg.to,
              scene: "p2p",
              to: nimMsg.to,
              updateTime: nimMsg.time,
              lastMsg: nimMsg
            }
          ];
          this.callbacks.onsessions(sessions);
        }
        // 对于类型为12的消息（客服介入），仍然触发onmsg回调，以便前端更新会话ID
        if (custom.type === 12) {
          // 触发onmsg回调
          if (this.callbacks.onmsg) {
            this.callbacks.onmsg(nimMsg);
          } else {
            console.warn("onmsg回调未设置");
          }
        }
        return;
      }
      // 触发onmsg回调
      if (this.callbacks.onmsg) {
        this.callbacks.onmsg(nimMsg);
      } else {
        console.warn("onmsg回调未设置");
      }
    } catch (error) {
      console.error("处理会话消息失败:", error, message);
    }
  }

  /**
   * 处理系统消息
   */
  handleSystemMessage(message) {
    // 将云朵系统消息转换为NIM格式
    const nimSysMsg = this.convertToNimSysMessage(message);

    // 触发onsysmsg回调
    if (this.callbacks.onsysmsg) {
      this.callbacks.onsysmsg(nimSysMsg);
    }
  }

  /**
   * 模拟NIM的同步过程
   */
  simulateNimSync() {
    // 模拟获取用户信息
    setTimeout(() => {
      if (this.callbacks.onmyinfo) {
        const userInfo = this.getSimulatedUserInfo();
        this.callbacks.onmyinfo(userInfo);
      }
    }, 100);

    // 模拟获取会话列表
    setTimeout(() => {
      if (this.callbacks.onsessions) {
        const sessions = this.getSimulatedSessions();
        this.callbacks.onsessions(sessions);
      }
    }, 200);

    // 模拟同步完成
    setTimeout(() => {
      if (this.callbacks.onsyncdone) {
        this.callbacks.onsyncdone();
      }
    }, 300);
  }

  /**
   * 获取模拟的用户信息
   */
  getSimulatedUserInfo() {
    const { account } = this.options;
    return {
      account: account,
      nick: "访客用户",
      avatar: "",
      sign: "",
      gender: "unknown",
      email: "",
      birth: "",
      tel: "",
      custom: JSON.stringify({ webtype: "web" }),
      createTime: Date.now(),
      updateTime: Date.now()
    };
  }

  /**
   * 获取模拟的会话列表
   */
  getSimulatedSessions() {
    // 这里可以根据实际业务需求返回模拟的会话列表

    // 返回模拟的会话列表，包含正确的会话结构
    // 这里可以根据实际业务需求返回真实的会话数据
    const sessions = [
      {
        id: `p2p-${this.options.account}`,
        scene: "p2p",
        to: this.options.account,
        updateTime: Date.now()
      }
    ];
    return sessions;
  }

  /**
   * 将云朵消息转换为NIM格式
   */
  convertToNimMessage(yunduoMsg) {
    console.log("转换云朵消息到NIM格式:", yunduoMsg);
    if (yunduoMsg.type === 0 && yunduoMsg.body && yunduoMsg.body.msg) {
      try {
        let tempMsg = JSON.parse(yunduoMsg.body.msg)
        if (tempMsg && tempMsg.url) {
          // 确保文件对象包含size字段，避免前端计算文件大小时出现NaN
          if (!tempMsg.size) {
            tempMsg.size = 0;
          }
          yunduoMsg.file = tempMsg
          yunduoMsg.body = tempMsg.url
          yunduoMsg.type = 6
        }
      } catch (e) {

      }
    } else if (yunduoMsg.type === 1 && yunduoMsg.body && yunduoMsg.body.url) {
      // 处理直接的图片消息
      // 确保文件对象包含size字段，避免前端计算文件大小时出现NaN
      if (!yunduoMsg.body.size) {
        yunduoMsg.body.size = 0;
      }
      yunduoMsg.file = yunduoMsg.body
    }
    // 解析ext字段
    let ext = {};
    if (yunduoMsg.ext) {
      try {
        ext = typeof yunduoMsg.ext === "string" ? JSON.parse(yunduoMsg.ext) : yunduoMsg.ext;
      } catch (e) {
        console.warn("解析ext字段失败:", e);
      }
    }

    // 解析body字段
    let body = {};
    if (yunduoMsg.body) {
      try {
        body = typeof yunduoMsg.body === "string" ? JSON.parse(yunduoMsg.body) : yunduoMsg.body;
      } catch (e) {
        console.warn("解析body字段失败:", e);
      }
    }
    // 映射消息类型：云朵的100类型对应NIM的'text'类型
    let nimType = "text";
    // 首先检查是否是图片消息
    if (yunduoMsg.body && yunduoMsg.body.url && yunduoMsg.body.ext && /(jpg|jpeg|png|gif|bmp)/i.test(yunduoMsg.body.ext)) {
      nimType = "image";
      // 确保file字段存在
      if (!yunduoMsg.file) {
        yunduoMsg.file = yunduoMsg.body;
      }
    } else if (yunduoMsg.ext && typeof ext.type !== "undefined") {
      nimType = "custom";
    } else if (yunduoMsg.type === 100) {
      nimType = "text";
    } else if (yunduoMsg.type === 1) {
      nimType = "image";
    } else if (yunduoMsg.type === 2) {
      nimType = "audio";
    } else if (yunduoMsg.type === 6) {
      nimType = "file";
    } else if (yunduoMsg.type === 10) {
      nimType = "custom";
    }
    // 如果yunduoMsg.from是整数，转换为字符串
    let from = yunduoMsg.from || "";
    let flow = "in"
    if (/^\d+$/.test(from)) {
      yunduoMsg.from = yunduoMsg.from.toString();
      from = "in"
    } else {
      flow = "out"
    }
    // 构建NIM消息格式
    const nimMsg = {
      idClient: yunduoMsg.msgidclient || Date.now().toString(),
      idServer: yunduoMsg.msgidclient || "",
      type: nimType,
      scene: "p2p",
      from: flow === "out" ? this.options.account : yunduoMsg.userId, // 接收者是当前访客
      to: flow === "out" ? yunduoMsg.userId : this.options.account, // 接收者是当前访客
      time: yunduoMsg.sendtime || yunduoMsg.createTime || Date.now(),
      status: "success",
      fromNick: yunduoMsg.fromNick,
      content: JSON.stringify(yunduoMsg.body),
      custom: JSON.stringify(ext),
      sessionId: yunduoMsg.conversationId ? `p2p-${yunduoMsg.conversationId}` : "",
      flow: flow,
      // text: body.msg && body.msg.text ? body.msg.text : "",
      body: body
    };
    // 对于文本消息，添加text字段
    if (nimType === "text") {
      nimMsg.text = body.msg || yunduoMsg.content || "";
    }
    if ((nimType === "file" || nimType === "image") && yunduoMsg.file) {
      nimMsg.file = yunduoMsg.file
    }

    // if (ext && ext.type && ext.type === 12) {
    //   // (content:{"msg":{"result":23564,"text":"客服-小小客服介入会话"}})
    //   if (body.msg) {
    //     const msgContentJson= typeof body.msg === "string" ? JSON.parse(body.msg) : body.msg
    //     if (msgContentJson) {
    //
    //     }
    //   }
    // }
    // 处理类型为12的消息（客服介入），从body.msg中提取conversationId
    if (ext && ext.type && ext.type === 12) {
      if (body.msg) {
        const msgContentJson = typeof body.msg === "string" ? JSON.parse(body.msg) : body.msg;
        if (msgContentJson && msgContentJson.conversationId) {
          // 将conversationId添加到消息中，便于前端更新
          yunduoMsg.conversationId = msgContentJson.conversationId;
          nimMsg.sessionId = `p2p-${msgContentJson.conversationId}`;
          // 将conversationId添加到nimMsg中，便于前端直接获取
          nimMsg.conversationId = msgContentJson.conversationId;
        }
      }
    }
    if (ext && ext.type && ext.type === 8) {
      // 添加cardMark属性，用于标识需要隐藏的卡片消息
      nimMsg.cardMark = ""
    }

    console.log("最终NIM消息:", nimMsg);
    return nimMsg;
  }

  /**
   * 将云朵系统消息转换为NIM格式
   */
  convertToNimSysMessage(yunduoSysMsg) {
    // 根据云朵系统消息类型转换为NIM系统消息
    if (yunduoSysMsg.msgType === "REVOKE") {
      return {
        type: "deleteMsg",
        from: yunduoSysMsg.fromUserId || "",
        to: yunduoSysMsg.toUserId || this.options.account,
        time: yunduoSysMsg.createTime || Date.now(),
        idClient: yunduoSysMsg.msgId || "",
        attach: {
          msgId: yunduoSysMsg.msgId || ""
        }
      };
    }

    return {
      type: "custom",
      from: yunduoSysMsg.fromUserId || "",
      to: yunduoSysMsg.toUserId || this.options.account,
      time: yunduoSysMsg.createTime || Date.now(),
      attach: yunduoSysMsg
    };
  }

  /**
   * 处理重连逻辑
   */
  handleReconnect() {
    // if (this.reconnectAttempts >= this.maxReconnectAttempts) {
    //   console.log('达到最大重连次数，停止重连');
    //   return;
    // }

    // 触发onwillreconnect回调
    if (this.callbacks.onwillreconnect) {
      this.callbacks.onwillreconnect({
        duration: this.reconnectInterval,
        retryCount: this.reconnectAttempts
      });
    }

    this.reconnectAttempts++;

    setTimeout(() => {
      this.initWebSocket();
    }, this.reconnectInterval);
  }

  /**
   * 启动心跳检测
   */
  startHeartbeat() {
    this.heartbeatInterval = setInterval(() => {
      this.heartbeatreqCount++;
      // console.log('心跳检测', this.heartbeatreqCount, this.heartbeatresCount);
      if (this.heartbeatreqCount - this.heartbeatresCount > 3) {
        // 心跳包未收到，重连
        this.stopHeartbeat();
        this.handleReconnect();
        return;
      }
      if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
        const heartbeatMsg = {
          type: "HB_REQ",
          c: this.heartbeatreqCount
        };
        this.websocket.send(JSON.stringify(heartbeatMsg));
      }
    }, 8000); // 8秒一次心跳
  }

  /**
   * 停止心跳检测
   */
  stopHeartbeat() {
    if (this.heartbeatInterval) {
      clearInterval(this.heartbeatInterval);
      this.heartbeatInterval = null;
      this.heartbeatreqCount = 0;
      this.heartbeatresCount = 0;
    }
  }
  /**
   * 生成UUID
   */
  generateUUID() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0;
      const v = c === "x" ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  /**
   * NIM SDK兼容方法 - 发送文件消息
   */
  sendFile(options) {
    // 云朵长连接暂不支持文件发送，使用模拟实现
    console.warn("云朵长连接暂不支持文件发送，使用模拟实现");

    if (options.done) {
      setTimeout(() => {
        options.done(new Error("云朵长连接暂不支持文件发送"), null);
      }, 100);
    }
  }

  /**
   * NIM SDK兼容方法 - 获取历史消息
   */
  getHistoryMsgs(options) {
    console.log("云朵长连接获取历史消息:", options);
    if (!options.conversationId || options.conversationId === "1") {
      return;
    }
    if (this.scrollStop) {
      return;
    }
    let that = this;
    this.scrollStop = true;
    let conversationId = options.conversationId;
    let more = this.scollmore;
    if (this.scrollconversationId !== "") {
      conversationId = this.scrollconversationId;
    } else {
      this.scrollconversationId = conversationId;
    }

    // 异步获取聊天记录
    const getChatMessagesAsync = async () => {
      try {
        const rsaKey = getRsaKey();
        console.log("查询聊天记录===》", conversationId, more);

        // 构造请求参数，使用用户提供的格式
        const params = {
          key: EncryptRSA(rsaKey.join("")),
          content: encryptAES(JSON.stringify({
            companyId: this.initParams.companyId,
            conversationId: conversationId,
            visitSign: this.initParams.visitSign,
            more: more // 根据需求设置
          }), rsaKey.join("")),
          ext: encryptAES(JSON.stringify({
            groupConversationId: options.conversationId
          }))
        };

        const res = await getChatMessages(params);
        that.scrollStop = false;
        if (res.code === "1" && res.data) {
          if (res.data.length > 0) {
            if (that.scrollconversationId !== res.data[0].conversationId) {
              that.scrollconversationId = res.data[0].conversationId;
              that.scollmore = false;
            } else {
              that.scollmore = true;
            }
          } else {
            that.scrollStop = true;
          }
          return res.data;
        }
        return null;
      } catch (error) {
        that.scrollStop = true;
        console.error("获取聊天记录失败:", error);
        return null;
      }
    };

    // 处理查询请求
    if (options.done) {
      // 异步获取历史消息
      (async () => {
        try {
          const chatMessages = await getChatMessagesAsync();
          let formattedMessages = [];

          if (chatMessages && Array.isArray(chatMessages)) {
            // 将云朵消息格式转换为NIM SDK兼容格式
            formattedMessages = chatMessages.map((msg, index) => {
              // 处理消息类型

              // 将云朵消息转换为NIM格式
              const nimMsg = this.convertToNimMessage(msg);
              console.log("转换后的NIM消息:", nimMsg);
              const custom = nimMsg.custom ? JSON.parse(nimMsg.custom) : {};
              if (typeof custom.type !== "undefined" && (custom.type === 0 || custom.type === 12)) {
                // 会话激活
                if (this.callbacks.onsessions) {
                  const sessions = [
                    {
                      id: "p2p-" + nimMsg.to,
                      scene: "p2p",
                      to: nimMsg.to,
                      updateTime: nimMsg.time,
                      lastMsg: nimMsg
                    }
                  ];
                  this.callbacks.onsessions(sessions);
                }
              }
              return nimMsg;
            });

            // 根据reverse参数排序消息
            if (options.reverse) {
              formattedMessages.sort((a, b) => b.time - a.time);
            } else {
              formattedMessages.sort((a, b) => a.time - b.time);
            }

            // 应用limit限制
            if (options.limit && formattedMessages.length > options.limit) {
              formattedMessages = formattedMessages.slice(0, options.limit);
            }

            console.log("云朵长连接获取历史消息成功:", formattedMessages);
            options.done(null, {"msgs": formattedMessages});
          } else {
            // 获取失败或没有数据，返回空数组作为降级方案
            console.warn("云朵长连接获取历史消息失败或没有数据，返回空数组");
            options.done(null, {"msgs": []});
          }
        } catch (error) {
          console.error("获取历史消息失败:", error);
          // 返回空数组作为降级方案
          options.done(null, {"msgs": []});
        }
      })();
    }
  }

  /**
   * NIM SDK兼容方法 - 获取用户信息
   */
  getUsers(options) {
    console.log("获取用户信息:", options.accounts);
    // 创建客服信息缓存
    if (!this.userInfoCache) {
      this.userInfoCache = new Map();
    }

    // 批量获取客服信息
    const getUsersBatchInfoAsync = async (accounts) => {
      try {
        const rsaKey = getRsaKey();

        const params = {
          key: EncryptRSA(rsaKey.join("")),
          content: encryptAES(JSON.stringify({
            accounts: accounts,
            companyId: this.initParams.companyId,
            childChannelId: this.initParams.childChannelId,
            visitSign: this.initParams.visitSign
          }), rsaKey.join("")),
          ext: encryptAES(JSON.stringify({
            groupConversationId: this.initParams.groupConversationId
          }))
        };

        const res = await getUsersBatchInfo(params);
        if (res.code === "1" && res.data) {
          return res.data;
        }
        return null;
      } catch (error) {
        console.error("批量获取客服信息失败:", error);
        return null;
      }
    };

    // 处理查询请求
    if (options.done) {
      // 异步获取用户信息
      (async () => {
        try {
          const users = [];

          // 检查缓存中是否已有所有账号的信息
          const cachedAccounts = [];
          const uncachedAccounts = [];

          for (const account of options.accounts) {
            if (this.userInfoCache.has(account)) {
              cachedAccounts.push(account);
            } else {
              uncachedAccounts.push(account);
            }
          }

          // 从缓存中获取已缓存的信息
          for (const account of cachedAccounts) {
            users.push(this.userInfoCache.get(account));
          }

          // 批量获取未缓存的信息
          if (uncachedAccounts.length > 0) {
            const batchInfo = await getUsersBatchInfoAsync(uncachedAccounts);

            if (batchInfo && Array.isArray(batchInfo)) {
              // 创建账号到用户信息的映射
              const userInfoMap = new Map();
              batchInfo.forEach(user => {
                userInfoMap.set(user.userId + "", user);
              });

              // 处理每个账号
              for (const account of uncachedAccounts) {
                if (userInfoMap.has(account)) {
                  const userInfo = userInfoMap.get(account);
                  const formattedUser = {
                    account: userInfo.userId + "",
                    nick: userInfo.nickName || userInfo.nick || "客服用户",
                    avatar: userInfo.avatar || "",
                    sign: userInfo.sign || "",
                    gender: userInfo.gender || "unknown"
                  };
                  users.push(formattedUser);
                  this.userInfoCache.set(account, formattedUser);
                } else {
                  // 返回默认信息作为降级方案
                  const defaultUser = {
                    account: account,
                    nick: "客服用户",
                    avatar: "",
                    sign: "",
                    gender: "unknown"
                  };
                  users.push(defaultUser);
                  this.userInfoCache.set(account, defaultUser);
                }
              }
            } else {
              // 批量获取失败，为每个账号返回默认信息
              for (const account of uncachedAccounts) {
                const defaultUser = {
                  account: account,
                  nick: "客服用户",
                  avatar: "",
                  sign: "",
                  gender: "unknown"
                };
                users.push(defaultUser);
                this.userInfoCache.set(account, defaultUser);
              }
            }
          }

          // 确保返回顺序与请求顺序一致
          const sortedUsers = options.accounts.map(account =>
            users.find(user => user.account === account)
          );

          console.log("云朵长连接获取用户信息:", sortedUsers);
          options.done(null, sortedUsers);
        } catch (error) {
          console.error("获取用户信息失败:", error);
          // 返回模拟的用户信息作为降级方案
          const fallbackUsers = options.accounts.map(account => ({
            account: account,
            nick: "客服用户",
            avatar: "",
            sign: "",
            gender: "unknown"
          }));
          options.done(null, fallbackUsers);
        }
      })();
    }
  }
  mergeSessions(existingSessions, newSessions) {
    // 创建会话映射，用于快速查找和更新
    const sessionMap = new Map();

    // 将现有会话添加到映射中
    if (existingSessions && Array.isArray(existingSessions)) {
      existingSessions.forEach(session => {
        if (session.id) {
          sessionMap.set(session.id, { ...session });
        }
      });
    }

    // 合并新会话
    if (newSessions && Array.isArray(newSessions)) {
      newSessions.forEach(session => {
        if (session.id) {
          if (sessionMap.has(session.id)) {
            // 会话已存在，进行合并更新
            const existingSession = sessionMap.get(session.id);
            const mergedSession = {
              ...existingSession,
              ...session,
              // 保留最新的更新时间
              updateTime: Math.max(existingSession.updateTime || 0, session.updateTime || 0)
            };

            // 特殊处理未读消息数
            if (session.unread !== undefined) {
              mergedSession.unread = session.unread;
            }

            sessionMap.set(session.id, mergedSession);
          } else {
            // 新会话，直接添加
            sessionMap.set(session.id, { ...session });
          }
        }
      });
    }

    // 转换为数组并排序
    const mergedSessions = Array.from(sessionMap.values());

    // 按更新时间降序排序（最新的会话在前）
    mergedSessions.sort((a, b) => {
      const timeA = a.updateTime || 0;
      const timeB = b.updateTime || 0;
      return timeB - timeA;
    });

    return mergedSessions;
  }
  /**
   * NIM SDK兼容方法 - 更新用户信息
   */
  updateMyInfo(options) {
    // 触发onupdatemyinfo回调
    if (this.callbacks.onupdatemyinfo && options.done) {
      setTimeout(() => {
        const updatedUser = {
          account: this.options.account,
          ...options
        };
        this.callbacks.onupdatemyinfo(updatedUser);
        options.done(null, updatedUser);
      }, 100);
    }
  }

  /**
   * NIM SDK兼容方法 - 销毁连接
   */
  destroy(options) {
    this.stopHeartbeat();

    if (this.websocket) {
      this.websocket.close();
      this.websocket = null;
    }

    this.isConnected = false;
    this.isConnecting = false;

    if (options && options.done) {
      setTimeout(() => {
        options.done();
      }, 100);
    }
  }

  /**
   * 事件监听方法（NIM SDK兼容）
   */
  on(event, callback) {
    if (!this.eventListeners[event]) {
      this.eventListeners[event] = [];
    }
    this.eventListeners[event].push(callback);
  }

  /**
   * 触发事件方法（NIM SDK兼容）
   */
  triggerEvent(event, data) {
    const listeners = this.eventListeners[event];
    if (listeners) {
      listeners.forEach(callback => {
        try {
          callback(data);
        } catch (error) {
          console.error(`触发事件${event}时出错`, error);
        }
      });
    }
  }
}

/**
 * 静态getInstance方法，模拟NIM.getInstance
 */
YunduoAdapter.getInstance = function(options) {
  return new Promise((resolve) => {
    const adapter = new YunduoAdapter(options);
    resolve(adapter);
  });
};

// 导出适配器
window.YunduoNIM = YunduoAdapter;
export default YunduoAdapter;



// WEBPACK FOOTER //
// ./src/utils/yunduoAdapter.js